// material-ui
import { useTheme } from '@mui/material/styles';
import logo from 'assets/images/logo.svg';
import logoDark from 'assets/images/logo-dark.svg';

// ==============================|| LOGO SVG ||============================== //

const Logo = () => {
    const theme = useTheme();
    return <img src={theme.palette.mode === 'dark' ? logoDark : logo} alt="Berry" width="100" />;
};

export default Logo;
